// Invoice slice
import { StateCreator, StoreApi } from "zustand";
import { InvoiceExtended } from "@/types";
import { AppStoreState } from "../appStore";
type SetState = StoreApi<AppStoreState>["setState"];
type GetState = StoreApi<AppStoreState>["getState"];

const createInvoiceSlice: StateCreator<
  AppStoreState,
  [],
  [],
  Pick<
    AppStoreState,
    | "invoices"
    | "selectedInvoice"
    | "setInvoices"
    | "setSelectedInvoice"
    | "fetchInvoices"
    | "uploadInvoice"
    | "removeInvoice"
  >
> = (set: SetState, get: GetState) => ({
  invoices: [],
  selectedInvoice: undefined,
  setInvoices: (invoices: InvoiceExtended[] = []) => set({ invoices }),
  setSelectedInvoice: (invoice: InvoiceExtended | undefined) =>
    set({ selectedInvoice: invoice }),
  fetchInvoices: async () => {
    const user = get().user;
    if (!user?.selectedReport?.id) return;
    const res = await fetch(
      `/api/invoice/search?reportId=${user.selectedReport.id}`
    );
    const data = await res.json();
    set({ invoices: Array.isArray(data) ? data : [] });
  },
  uploadInvoice: async (files: File[]) => {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append("file", file, file.name);
    });
    const response = await fetch("/api/upload/invoice", {
      method: "POST",
      body: formData,
    });
    const data = await response.json();
    await get().fetchInvoices();
    return data;
  },
  removeInvoice: async (invoiceId: string) => {
    await fetch(`/api/invoice/remove`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ invoiceId }),
    });
    await get().fetchInvoices();
  },
});

export default createInvoiceSlice;
